import { useFlags } from 'launchdarkly-react-client-sdk';
import LogoSvg from './vts-marketplace-logo-beta.svg';
import LogoSvgWhite from './vts-marketplace-logo-white.svg';
import MobileLogoSvg from './vts-marketplace-logo-beta-mobile.svg';
import s from './Logo.module.less';

export default function Logo() {
  const flags = useFlags();
  return flags['search-redesign'] ? (
    <>
      <figure className={s.logoContainer}>
        <LogoSvgWhite fill="currentColor" />
      </figure>
      <figure className={s.mobileLogoContainer}>
        <LogoSvgWhite fill="currentColor" />
      </figure>
    </>
  ) : (
    <>
      <figure className={s.logoContainer}>
        <LogoSvg fill="currentColor" />
      </figure>
      <figure className={s.mobileLogoContainer}>
        <MobileLogoSvg fill="currentColor" />
      </figure>
    </>
  );
}
